

















































































































































































































































import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import './dashboard.less';
import {Validations} from 'vuelidate-property-decorators';
import {required, email, minValue, minLength, maxLength,numeric} from 'vuelidate/lib/validators';
import FileUpload from 'vue-upload-component'
import Simplemodal from '../simplemodal/simplemodal.vue';

import {submitForm,get} from '../../service/webclient/webclient';
import SimpleDropdown from "@/components/simple-dropdown/simple-dropdown.vue";


@Component({
  components: {
    FileUpload,
    Simplemodal,
    SimpleDropdown
  }
})
export default class Dashboard extends Vue {

  private userData = {
    first_name: '',
    last_name: '',
    zip_code: '',
    city: '',
    street_name: '',
    street_type: null,
    street_number: '',
    email: '',
    phone: '',
    house_postcode: '',
    house_city: '',
    house_street_name: '',
    house_street_type: null,
    house_street_number: '',
    dealer_company_name: '',
    implementer_company_name: '',
    contributing_seller_name: '',
  }
  private images=[];
  private invoices=[];

  private modalData={
    title : 'Title',
    content: '',
    key: 'registrationModify'
  };

  private texts={
    title: 'Adatok módosítása!',
    success: 'Sikeresen módosította adatait.',
    error: 'Adatok módosítása nem sikerült.',

  };

  public uploadImageModel =[];
  public uploadInvoiceModel =[];

  streetTypes = [
    {title:"utca", id:"utca" },
    {title:"út", id:"út" },
    {title:"köz", id:"köz" },
    {title:"tér", id:"tér" },
    {title:"dűlő", id:"dűlő" },
    {title:"körút", id:"körút" },
    {title:"lépcső", id:"lépcső" },
    {title:"lejtő", id:"lejtő" }
  ]
  mounted() {
    let self = this;
    self.getUserData();
  }

  updateData(){
    let self = this;
    self.$v.userData.$touch();
    if(!self.$v.userData.$invalid){
      if(self.userData.street_type != null){
        self.userData.street_type = self.userData.street_type.id
      }
      if(self.userData.house_street_type != null){
        self.userData.house_street_type = self.userData.house_street_type.id
      }
      submitForm('#regModifyForm',self.userData).then((resp)=>{
        self.modalData.title=self.texts.title;
        if(resp.hiba==0){
          self.modalData.content=self.texts.success;
        }
        else{
          self.modalData.content=self.texts.error;
        }
        $('#'+self.modalData.key).modal('show');
      });
    }
  }

  deleteImage(id){
    let self = this;
    submitForm('#deletePictureForm',{id:id}).then((resp)=>{
        self.getUserData();
      });
  }
  deleteInvoice(id){
    let self = this;
    submitForm('#deleteInvoiceForm',{id:id}).then((resp)=>{
        self.getUserData();
      });
  }

  inputImage(newFile,oldFile){
    if (newFile && !oldFile) {
      this.$refs.uploadImage.active = true;
    }
  }

  inputInvoice(newFile,oldFile){
    if (newFile && !oldFile) {
      this.$refs.uploadInvoice.active = true;
    }
  }


  inputFilter(newFile, oldFile, prevent) {
    if (newFile && !oldFile) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
        return prevent()
      }
      if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
        return prevent()
      }
    }
  }

  getUserData(){
    let self = this;
    get('api/ajax-get-userdata.php').then((resp)=>{
      resp=JSON.parse(resp);
      self.images=resp.images;
      self.invoices=resp.invoices;
      for (const property in self.userData) {
        if(property == 'street_type' || property == 'house_street_type'){
          self.userData[property] = this.getValue(resp.user[property]);
        } else{
          self.userData[property] = resp.user[property];
        }
      }
    });
  }
  validatePhone(phone) {
    let regex = /(?:\+)(?:\d{1,2})(?:\ \d{1,2})(?:\ )(\d{3,4})(?:\ )?(\d{3,4})$/;
    if (!phone || phone.length == 0) {
      return true;
    } else {
      return regex.test(phone);
    }
  };

  getValue(id){
    const temp = this.streetTypes.filter((type)=>{
      return type.id == id
    })
    return temp.length > 0 ? temp[0] : null
  }


  @Validations()
    validations = {
        userData : {
          first_name: {required, minLength: minLength(3)},
          last_name: {required, minLength: minLength(2)},
          zip_code: {required, minLength: minLength(4), numeric},
          city: {required, minLength: minLength(2)},
          street_name: {required, minLength: minLength(2)},
          street_type: {required},
          street_number: {required, minLength: minLength(1)},
          email: {required, email},
          phone: {validatePhone: this.validatePhone, required},
          house_postcode: {required, minLength: minLength(4),numeric},
          house_city: {required, minLength: minLength(3)},
          house_street_name: {required, minLength: minLength(2)},
          house_street_type: {required},
          house_street_number: {required, minLength: minLength(1)},
          dealer_company_name: {required, minLength: minLength(3)},
          implementer_company_name: {},
        }
    }

    @Watch('uploadImageModel',{immediate: true, deep: true})
    watchImage(){
      if(this.$refs.uploadImage && this.$refs.uploadImage.uploaded){
        this.getUserData();
      }
    }
    @Watch('uploadInvoiceModel',{immediate: true, deep: true})
    watchInvoice(){
      if(this.$refs.uploadImage && this.$refs.uploadImage.uploaded){
        this.getUserData();
      }
    }


}
